/* eslint-disable max-len */

import { createContext, useCallback, useEffect, useState } from 'react'
import { Modal, ModalBody, ModalContent, ModalOverlay, useDisclosure } from '@chakra-ui/react'

import { useCustomContext } from 'utils/helpers/useCustomContext'
import { GenericStateType } from 'utils/types'

import { DisplayModalContextType, DisplayModalStateType } from './displayModalTypes'

const INITIAL_DISPLAY_MODAL_CONTEXT: DisplayModalContextType = {
  openDialog: () => null,
  closeModal: () => null,
  displayModalState: {
    error: '',
    loading: false,
    state: {
      options: {
        content: null,
        variant: 'primary',
      },
    },
  },
}

const DisplayModalContext = createContext<DisplayModalContextType>(
  INITIAL_DISPLAY_MODAL_CONTEXT,
)

const DisplayModalProvider: React.FC = ({ children }) => {
  const { isOpen, onOpen, onClose: closeModal } = useDisclosure()
  const [displayModalState, setDisplayModalState] = useState<
    GenericStateType<DisplayModalStateType>
  >(INITIAL_DISPLAY_MODAL_CONTEXT.displayModalState)

  useEffect(() => {
    if (!isOpen)
      setDisplayModalState(prevState => ({
        ...prevState,
        state: { options: { content: null, variant: 'primary' } },
      }))
  }, [isOpen])

  const openDialog: DisplayModalContextType['openDialog'] = useCallback(
    ({ content, variant }) => {
      onOpen()
      setDisplayModalState(prevState => ({ ...prevState, state: { options: { content, variant } } }))
    },
    [onOpen, setDisplayModalState],
  )

  return (
    <DisplayModalContext.Provider
      value={{ displayModalState, openDialog, closeModal }}>
      {children}
      <Modal closeOnEsc={false} variant={displayModalState.state.options.variant} closeOnOverlayClick={false} isCentered={displayModalState.state.options.variant !== 'tertiary' } isOpen={isOpen} onClose={closeModal}>
      { displayModalState.state.options.variant === 'tertiary' ?
      <>
        <ModalOverlay bgColor={'#171923'} />
        <ModalContent bgColor={'transparent'} shadow={'0'} h={{ base:  'full', md: 'sm' }} w={{ base: 'xs', md: 'md' }} >
          <ModalBody bgColor={'transparent'}>
            {displayModalState.state.options.content}
          </ModalBody>
        </ModalContent>
      </>  :
      <>
        <ModalOverlay />
        <ModalContent
          h={{ base: displayModalState.state.options.variant === 'secondary' ? 'full' : 'xs', md: 'sm' }}
          w={{ base: 'full', md: 'md' }}>
          <ModalBody>
            {displayModalState.state.options.content}
          </ModalBody>
        </ModalContent>
      </>
    }
      </Modal>
    </DisplayModalContext.Provider>
  )
}

const useDisplayModal = () =>
  useCustomContext<DisplayModalContextType>(DisplayModalContext)

export { DisplayModalProvider, useDisplayModal }
